var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drafts"},[_c('common-table',{ref:"draftsTable",attrs:{"apiKey":_vm.tableConfig.apiKey,"autoLoad":_vm.tableConfig.autoLoad,"search-params":_vm.searchForm,"columns":_vm.tableConfig.columns,"options":_vm.tableConfig.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }